import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Icon,
  Image,
  Menu,
  Sidebar,
  List,
  ListItem,
  Button
} from 'semantic-ui-react';

import logo from 'resources/logo.png';
import * as styles from './NavBar.less';
import NavBarMobileMenu from './NavBarMobileMenu';
import LocaleToggle from '../LocaleToggle';
import NavBarButtonMenu from './NavBarButtonMenu';
import NavBarMenu from './NavBarMenu';

export default class NavBarMobile extends Component {
  state = {};
  handleContextRef = contextRef => this.setState({ contextRef });

  render() {
    // const {contextRef} = this.state;

    return (
      <Sidebar.Pushable style={{ transform: 'none' }}>
        <div ref={this.handleContextRef}>
          <Sidebar
            as={Menu}
            animation="overlay"
            icon="labeled"
            inverted
            items={[...this.props.leftItems, ...this.props.rightItems]}
            vertical
            visible={this.props.visible}
          >
            <List>
              <ListItem onClick={this.props.onPusherClick}>
                <NavBarMobileMenu menuList={[...this.props.leftItems]} />
                {/*<NavBarMobileMenu menuList={[...this.props.rightItems]}/>*/}
              </ListItem>
              <LocaleToggle />
            </List>
          </Sidebar>
          <Sidebar.Pusher
            dimmed={this.props.visible}
            onClick={this.props.onPusherClick}
            className={styles.pusher}
          >
            <Menu fixed="top" inverted className={styles.container}>
              <Menu.Menu position="left">
                <Menu.Item onClick={this.props.onToggle}>
                  <Icon name="sidebar" />
                </Menu.Item>
              </Menu.Menu>
              <Menu.Item className={styles.itemContainer}>
                <Image size="tiny" src={logo} />
              </Menu.Item>
              <Menu.Menu position="right">
                <NavBarMenu menuList={this.props.rightItems} />
                <Menu.Item>
                  <Menu.Item>
                    <Button id={'tkbButtonMobile'} onClick={this.props.onTkb}>
                      TKB90 : 95%
                      <Icon name="info circle" style={{ paddingLeft: '5px' }} />
                    </Button>
                  </Menu.Item>
                </Menu.Item>
              </Menu.Menu>
            </Menu>
            {this.props.children}
          </Sidebar.Pusher>
        </div>
      </Sidebar.Pushable>
    );
  }
}

NavBarMobile.propTypes = {
  children: PropTypes.node,
  leftItems: PropTypes.arrayOf(PropTypes.object),
  onPusherClick: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  rightItems: PropTypes.arrayOf(PropTypes.object),
  visible: PropTypes.bool.isRequired,
  onTkb: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBarMobile.js